import { fetchDuyurular as fetchDuyurularAPI } from '../../services/WebsiteService';

export const FETCH_DUYURULAR_SUCCESS = "FETCH_DUYURULAR_SUCCESS";
export const FETCH_DUYURULAR_ERROR = "FETCH_DUYURULAR_ERROR";

const fetchDuyurularSuccess = (duyurular, pagination = null) => ({
    type: FETCH_DUYURULAR_SUCCESS,
    payload: { duyurular, pagination },
});

const fetchDuyurularError = (error) => ({
    type: FETCH_DUYURULAR_ERROR,
    payload: error,
});

export const fetchDuyurular = (duyurular = null, page = 1, perPage = 9) => {
    return async (dispatch) => {
        try {
            // Eğer duyurular parametre olarak gelmişse (fallback), onu kullan
            if (duyurular) {
                dispatch(fetchDuyurularSuccess(duyurular, null));
                return;
            }
            
            // API'den çek (sayfalama ile)
            const result = await fetchDuyurularAPI(page, perPage);
            dispatch(fetchDuyurularSuccess(result.items, result.pagination));
        } catch (error) {
            console.error('Duyurular fetch error:', error);
            dispatch(fetchDuyurularError(error.message));
            // Fallback: JSON'dan yükle
            try {
                const fallback = await import('../../data/duyurular.json');
                dispatch(fetchDuyurularSuccess(fallback.default, null));
            } catch (e) {
                dispatch(fetchDuyurularSuccess([], null));
            }
        }
    };
};
